import React from "react";
import { useDispatch } from "react-redux";
import CatalogList from "@components/Features/catalog/catalog-list/catalog-list";
import { CATALOG_PAGE_ADBLOCK_POSITIONS } from "@components/Features/catalog/catalog-utils";
import { setCatalogParamsSort, setCatalogTimeSort } from "@app/store/filtersSlice";
import { Pagination } from "@widgets/Pagination";
import { CatalogContentProps } from "./hooks/types";
import classes from "./CatalogScreen.module.scss";

export const CatalogContent = ({
    error,
    analyticsData,
    catalogTimeSort,
    catalogAllParamsSort,
    dataMemory,
    isFetching,
    isLoading,
    currentPage,
    header1,
    data,
    totalPages
}: CatalogContentProps) => {
    const dispatch = useDispatch();
    const shouldShowPagination = !isFetching && dataMemory.length > 0;

    return (
        <div className={classes["catalog-screen__error"]}>
            {!!error && (
                <div className={classes["catalog-screen__error-text"]}>Ошибка загрузки данных</div>
            )}

            {!error && (
                <>
                    <CatalogList
                        analyticsData={analyticsData}
                        onParamsSortChanged={(sort) => {
                            dispatch(setCatalogParamsSort(sort));
                        }}
                        onTimeSortChanged={(sort) => {
                            dispatch(setCatalogTimeSort(sort));
                        }}
                        showLoadMore={false}
                        timeSort={catalogTimeSort}
                        allParamsSort={catalogAllParamsSort}
                        data={dataMemory}
                        isDataLoading={isFetching || isLoading}
                        page={currentPage}
                        loadMore={() => {}}
                        forceSortShow={true}
                        title={header1}
                        total={data?.data?.total}
                        adBlockPositions={CATALOG_PAGE_ADBLOCK_POSITIONS}
                    />
                    {shouldShowPagination && (
                        <Pagination
                            className={classes["catalog-screen__pagination"]}
                            totalPages={totalPages}
                            currentPage={currentPage}
                        />
                    )}
                </>
            )}
        </div>
    );
};